import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from "./plugins/vuetify";
import goTo from 'vuetify/es5/services/goto'
import store from './store'
import { routes } from './routes'

Vue.config.productionTip = false
Vue.use(VueRouter)

const router = new VueRouter( {
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  mode: 'history',
  //base:  process.env.NODE_ENV === 'production' ? '/' : '/',
  routes
})



new Vue({
  render: function (createElement) {
    return createElement(App, {props: { prueba: this.prueba }})
  },

  vuetify,

  data: {
    prueba: 10
  },

  router,
  store,

  beforeMount: function () {
    this.prueba = this.$el.attributes['prueba'].value || 10;
  }
}).$mount('roscon')
